var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_vm._v(" Logged user: "+_vm._s(_vm.$store.state.username)+" "),_c('br'),_c('br'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }